import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

const CircleContainer = styled(Box)(({ _theme }) => ({
  width: 100,
  height: 100,
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const ConicBackgroundGray = styled(Box)(({ _theme }) => ({
  width: 100,
  height: 100,
  borderRadius: '50%',
  background: '#f3f3f3',
  position: 'absolute',
  top: 0,
  left: 0,
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    background: 'white',
    clipPath: `circle(36% at 50% 50%)`,
    top: 0,
    left: 0,
  },
}));

const ConicBackground = styled(Box)(({ _theme }) => ({
  width: 100,
  height: 100,
  borderRadius: '50%',
  background: 'conic-gradient(#D31314, #E86A2E, #FFC94A, #99E052, #19E63B)',
  position: 'absolute',
  top: 0,
  left: 0,
  '&::after': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    background: 'white',
    clipPath: `circle(36% at 50% 50%)`,
    top: 0,
    left: 0,
  },
}));

const CircleForeground = styled(Box)(({ _theme }) => ({
  width: 100,
  height: 100,
  background: `#ffffff`,
  position: 'absolute',
  top: 0,
  left: 0,
  transition: 'background 0.4s ease',
}));

const StatusCircle = ({ value }) => {
  const displayValueRef = useRef(0);
  const circleForegroundRef = useRef(null);
  const circleGrayRef = useRef(null);

  useEffect(() => {
    const duration = 500; // Duración de la animación en milisegundos
    const startTime = performance.now();
    const startValue = displayValueRef.current;

    let frameId;

    const animate = time => {
      const elapsedTime = time - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const newValue = startValue + progress * (value - startValue);

      displayValueRef.current = newValue;
      if (circleForegroundRef.current) {
        circleForegroundRef.current.style.background = `conic-gradient(#ffffff00 ${newValue}%, #fff ${newValue}% 100%)`;
        circleGrayRef.current.style.background = `conic-gradient(#ffffff00 ${newValue}%, #f3f3f3 ${newValue}%, #f3f3f3 100%)`;
      }

      if (progress < 1) {
        frameId = requestAnimationFrame(animate);
      } else {
        displayValueRef.current = value;
      }
    };

    frameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(frameId);
  }, [value]);

  return (
    <CircleContainer>
      <ConicBackground />
      <CircleForeground ref={circleForegroundRef} />
      <ConicBackgroundGray ref={circleGrayRef} />
    </CircleContainer>
  );
};

export default StatusCircle;
